var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#956D84"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40_3804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0625 24.9688H15.5002C15.0723 24.9688 14.7241 24.6206 14.7241 24.1926V18.4133H13.2292C12.8013 18.4133 12.4531 18.0651 12.4531 17.6372V15.1608C12.4531 14.7328 12.8013 14.3846 13.2292 14.3846H14.7241V13.1445C14.7241 11.9149 15.1102 10.8688 15.8406 10.1194C16.5742 9.36658 17.5995 8.96875 18.8055 8.96875L20.7596 8.97192C21.1869 8.97266 21.5344 9.3208 21.5344 9.74805V12.0474C21.5344 12.4753 21.1864 12.8235 20.7585 12.8235L19.4429 12.824C19.0416 12.824 18.9395 12.9044 18.9176 12.9291C18.8816 12.97 18.8387 13.0856 18.8387 13.4048V14.3845H20.6597C20.7968 14.3845 20.9296 14.4183 21.0437 14.4821C21.2899 14.6196 21.443 14.8798 21.443 15.1609L21.442 17.6373C21.442 18.0651 21.0939 18.4132 20.6659 18.4132H18.8387V24.1926C18.8387 24.6206 18.4905 24.9688 18.0625 24.9688ZM15.6621 24.0308H17.9006V17.9934C17.9006 17.7076 18.1332 17.4752 18.4188 17.4752H20.504L20.5049 15.3226H18.4187C18.1331 15.3226 17.9006 15.0902 17.9006 14.8044V13.4048C17.9006 13.0383 17.9379 12.6216 18.2145 12.3084C18.5487 11.9297 19.0754 11.886 19.4426 11.886L20.5964 11.8855V9.90967L18.8048 9.90674C16.8666 9.90674 15.6621 11.1475 15.6621 13.1445V14.8044C15.6621 15.0901 15.4297 15.3226 15.144 15.3226H13.3911V17.4752H15.144C15.4297 17.4752 15.6621 17.7076 15.6621 17.9934V24.0308ZM20.7578 9.90991H20.7579H20.7578Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40_3804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9688,
    height: 16,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.22a5128e0d5baa325aaf4e6f716af6cb.svg";
export { ForwardRef as ReactComponent };